import React from "react";
import PageShell from "../components/layout/PageShell";
import CinematicHero, { HeroOverlay } from "../components/layout/CinematicHero";
import Container from "../components/primitives/Container";
import Section from "../components/primitives/Section";
import Reveal from "../components/primitives/Reveal";
import SeoHead from "../components/seo/SeoHead";
import { IMAGES } from "../content/images";
import { INVESTOR_PORTAL } from "../content/site";

const InvestorPortal = () => {
  const { hero, paragraph, reassurance, cta } = INVESTOR_PORTAL;
  return (
    <PageShell>
      <SeoHead
        title="Investor Portal"
        description="A private access channel for existing partners and institutional counterparties. Access is provided upon verified engagement."
        path="/investor-portal"
        ogImage={IMAGES.investors_reading_corner}
        noIndex
      />
      <CinematicHero
        image={IMAGES.investors_reading_corner}
        imageAlt="A private office reading corner at blue hour."
        eager
        data-testid="investor-portal-hero"
      >
        <HeroOverlay
          eyebrow={hero.eyebrow}
          title={hero.headline}
          statement="A private access channel for existing partners and institutional counterparties."
          size="short"
        />
      </CinematicHero>

      <Section tone="light" className="py-16 md:py-20 lg:py-24" data-testid="investor-portal">
        <Container>
          <Reveal className="max-w-2xl">
            <p className="font-sans text-[17px] sm:text-[18px] leading-[1.75] text-navy/85">
              {paragraph}
            </p>
            <p className="mt-8 font-sans text-[15px] sm:text-[16px] leading-[1.75] text-navy/65">
              {reassurance}
            </p>
            <span aria-hidden="true" className="mt-12 block h-px w-12 bg-gold" />
            <a
              href={cta.href}
              data-testid="investor-portal-cta"
              className="group mt-10 inline-flex items-baseline gap-4 font-serif text-navy"
              style={{ fontSize: "clamp(22px, 2.2vw, 32px)" }}
            >
              <span className="relative">
                {cta.label}
                <span
                  aria-hidden="true"
                  className="absolute left-0 right-0 -bottom-1 h-px bg-gold scale-x-0 origin-left transition-transform duration-300 ease-out group-hover:scale-x-100"
                />
              </span>
              <span aria-hidden="true" className="text-gold text-lg leading-none">&rarr;</span>
            </a>
          </Reveal>
        </Container>
      </Section>
    </PageShell>
  );
};

export default InvestorPortal;
